"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlCardGroupAssignment = void 0;
var react_1 = __importDefault(require("react"));
var il_card_group_1 = require("../il-card-group/il-card-group");
var il_card_assignment_1 = require("../il-card-assignment/il-card-assignment");
var date_fns_1 = require("date-fns");
var assignment_state_enum_1 = require("../../shared/enums/assignment-state.enum");
var enums_1 = require("../../shared/enums");
var material_1 = require("@mui/material");
var styleDivider = {
    '&::before': {
        display: 'flex',
        mx: '0.625rem',
        height: '0.125rem',
        content: '""',
        backgroundColor: 'primary.dark',
    },
};
function IlCardGroupAssignment(_a) {
    var _b;
    var assignmentProps = _a.assignmentProps, dateToday = _a.dateToday, dateSelected = _a.dateSelected, sx = _a.sx, _c = _a.showMore, showMore = _c === void 0 ? false : _c, _d = _a.amountToShow, amountToShow = _d === void 0 ? 2 : _d, _e = _a.AssignmentComponent, AssignmentComponent = _e === void 0 ? il_card_assignment_1.IlCardAssignment : _e, overrideChildSx = _a.overrideChildSx, selectAssignment = _a.selectAssignment;
    var assignmentStateOrder = (_b = {},
        _b[assignment_state_enum_1.AssignmentStateEnum.OVERDUE] = 1,
        _b[assignment_state_enum_1.AssignmentStateEnum.STARTED] = 2,
        _b[assignment_state_enum_1.AssignmentStateEnum.ACTIVE] = 3,
        _b[assignment_state_enum_1.AssignmentStateEnum.UPCOMING] = 4,
        _b[assignment_state_enum_1.AssignmentStateEnum.COMPLETED] = 5,
        _b);
    var _f = react_1.default.useState(showMore), sliceChildren = _f[0], setSliceChildren = _f[1];
    var sortedChildren = __spreadArray([], assignmentProps, true).sort(function (a1, a2) {
        return assignmentStateOrder[a1.assignmentState] - assignmentStateOrder[a2.assignmentState] ||
            (0, date_fns_1.differenceInDays)(a1.dueDate, a2.dueDate) ||
            a1.sequence - a2.sequence;
    })
        .map(function (assignmentProp, index) {
        if (index > 0) {
            // Handle non-first cards
            switch (assignmentProp.assignmentState) {
                case assignment_state_enum_1.AssignmentStateEnum.COMPLETED:
                    // do nothing
                    break;
                case assignment_state_enum_1.AssignmentStateEnum.OVERDUE:
                    assignmentProp.deactivateCard = true;
                    break;
                default:
                    assignmentProp.assignmentState = assignment_state_enum_1.AssignmentStateEnum.UPCOMING;
                    break;
            }
            assignmentProp.sx = __assign({ borderTopWidth: 0 }, styleDivider);
        }
        else {
            // Handle the first card
            if (assignmentProp.assignmentState === assignment_state_enum_1.AssignmentStateEnum.UPCOMING &&
                (0, date_fns_1.isSameDay)(dateSelected, dateToday)) {
                assignmentProp.assignmentState = assignment_state_enum_1.AssignmentStateEnum.ACTIVE;
            }
            assignmentProp.sx = {
                '&::before': {},
            };
        }
        return (react_1.default.createElement(AssignmentComponent, __assign({}, assignmentProp, { key: index,
            onClick: function (e) {
                selectAssignment && selectAssignment(assignmentProp);
                assignmentProp.onClick && assignmentProp.onClick(e);
            },
            sx: __assign(__assign(__assign({}, assignmentProp.sx), { '& + &::before': {} }), overrideChildSx) })));
    });
    var slicedChildren = sortedChildren;
    if (sliceChildren) {
        slicedChildren = slicedChildren.slice(0, amountToShow);
        slicedChildren.push(react_1.default.createElement(material_1.Box, { sx: __assign(__assign({}, styleDivider), { bgcolor: 'background.default', textAlign: 'center' }) },
            react_1.default.createElement(material_1.Button, { sx: {
                    my: 'auto',
                    mt: '0.625rem',
                    mb: '0.75rem',
                    py: '0.25rem',
                    px: '2rem',
                    borderColor: 'action.disabledBackground',
                    borderWidth: '0.0625rem',
                    borderStyle: 'solid',
                    borderRadius: '1.5625rem',
                }, onClick: function () { return setSliceChildren(function (prev) { return !prev; }); }, variant: enums_1.ButtonVariantEnum.TEXT }, "Show More")));
    }
    return (0, il_card_group_1.IlCardGroup)({
        children: slicedChildren,
        sx: __assign({ borderWidth: '0.0625rem', borderColor: 'action.disabledBackground', borderRadius: '0.25rem', borderStyle: 'solid', '&:hover': {
                borderColor: 'action.disabled',
            } }, sx),
        lineSx: {
            ml: '0.625rem',
            mr: '0.625rem',
        },
    });
}
exports.IlCardGroupAssignment = IlCardGroupAssignment;
